export default {"src":"/_next/static/media/laugh.6fc7bba5.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};